import { useState, useMemo } from 'react';

export const usePagination = (data, defaultRecordsPerPage = 25) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(defaultRecordsPerPage);

    const totalRecords = data.length;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);

    const paginatedData = useMemo(() => {
        const firstRecordIndex = (currentPage - 1) * recordsPerPage;
        const lastRecordIndex = firstRecordIndex + recordsPerPage;
        return data.slice(firstRecordIndex, lastRecordIndex);
    }, [data, currentPage, recordsPerPage]);

    const nextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstRecordIndex = (currentPage - 1) * recordsPerPage + 1;
    const lastRecordIndex = Math.min(currentPage * recordsPerPage, totalRecords);

    return {
        paginatedData,
        totalPages,
        currentPage,
        recordsPerPage,
        setRecordsPerPage: (num) => {
            setRecordsPerPage(Number(num));
            setCurrentPage(1); // Reset to first page when changing record count
        },
        nextPage,
        prevPage,
        totalRecords,
        firstRecordIndex,
        lastRecordIndex,
    };
};